import React from 'react';
import BaseAbstract from './BaseAbstract';
import BaseButton from '../Base/Button';

export default class Button extends BaseAbstract {
    
    render() {

        return (
            <BaseButton onClick={ () => this.click() } { ...this.props }>
                { 
                    this.state.hasValue
                        ? this.renderValue()
                        : this.renderSkeleton({ animationOnly: true })
                }
            </BaseButton>
        );
    }

    renderValue() {

        return this.state.value.text;
    }

    click() {

        if (this.state.hasValue) {
                
            if (this.state.value.code)
                this.runCode();
            else if (this.state.value.link)
                window.open(this.state.value.link, '_blank');
        }
    }

    runCode() {

        const script = document.createElement('script');
        script.dataset.for = this.props.uid;
        script.innerHTML = `
            (() => {
                ${this.state.value.code}
            })();
            document.querySelector('[data-for="${this.props.uid}"]').remove();
        `;

        document.body.appendChild(script);
    }

}